import React from 'react'
import { Switch } from 'react-router-dom'

import {
  BankingGroups,
  BespokeRatings,
  BespokeRfqEmails,
  CompliancesValues,
  IsinsPage,
  Issuers,
  MarketIndexesPage,
  RfqsPage,
  TenantsPage,
  UsersPage,
  ProposedTenantsPage,
  KycCustomersPage,
} from '../pages'
import { CompliancesRules } from '../pages/Compliances/Rules/CompliancesRules'
import { TradesPage } from '../pages/Trades/TradesPage'
import { PrivateRoute } from './PrivateRoute'
import { routePaths } from './route-paths'

export const Routes = () => (
  <Switch>
    <PrivateRoute path={routePaths.private.compliance.rules} component={CompliancesRules} />
    <PrivateRoute path={routePaths.private.compliance.values} component={CompliancesValues} />
    <PrivateRoute path={routePaths.private.isins} component={IsinsPage} />
    <PrivateRoute path={routePaths.private.issuers.bespokeEmails} component={BespokeRfqEmails} />
    <PrivateRoute path={routePaths.private.issuers.bespokeRatings} component={BespokeRatings} />
    <PrivateRoute path={routePaths.private.issuers.bankingGroups} component={BankingGroups} />
    <PrivateRoute path={routePaths.private.issuers.all} component={Issuers} />
    <PrivateRoute path={routePaths.private.marketIndexes} component={MarketIndexesPage} />
    <PrivateRoute path={routePaths.private.rfqs} component={RfqsPage} />
    <PrivateRoute path={routePaths.private.tenants} component={TenantsPage} />
    <PrivateRoute path={routePaths.private.proposedTenants} component={ProposedTenantsPage} />
    <PrivateRoute path={routePaths.private.trades} component={TradesPage} />
    <PrivateRoute path={routePaths.private.users} component={UsersPage} />
    <PrivateRoute path={routePaths.private.kyc} component={KycCustomersPage} />
    <PrivateRoute path={routePaths.private.root} component={RfqsPage} />
  </Switch>
)
